import { ReviewPostPresenter } from '@/presentation/presenters/reviewPost/reviewPostPresenter'
import { OpenReviewPostEntryViewModel } from '@/presentation/viewmodels/reviewPost/openReviewPostEntryViewModel'
import { PostReviewViewModel } from '@/presentation/viewmodels/reviewPost/postReviewViewModel'
import { ReviewPostEntryDetailViewModel } from '@/presentation/viewmodels/reviewPost/reviewPostEntryDetailViewModel'
import { ReviewPostPageStateViewModel } from '@/presentation/viewmodels/reviewPost/reviewPostPageStateViewModel'

export function useReviewPostPresenter(
  presenter: ReviewPostPresenter = new ReviewPostPresenter(
    new ReviewPostPageStateViewModel(),
    new ReviewPostEntryDetailViewModel(),
    new OpenReviewPostEntryViewModel(),
    new PostReviewViewModel()
  )
) {
  return {
    isLoading: presenter.isLoading,
    initState: presenter.initState.bind(presenter),
    clickEntrySummary: presenter.clickEntrySummary.bind(presenter),
    getEntryDetail: presenter.getEntryDetail.bind(presenter),
    isAiReview: presenter.isAiReview.bind(presenter)
  }
}
